import React from 'react'

import { Button, Fade, Flex, FlexFull, P, Spinner, Title } from 'ui/acro'

import { useSurveyContext } from '../../_store'

const Loading = () => {
  const { state } = useSurveyContext()
  const errored = !!state.error

  return (
    <FlexFull
      justifyContent='center'
      alignItems='center'
      bg='black'
      color='white'
      padding='38px'
    >
      {!errored && <Spinner height='60px' width='60px' />}
      <Fade inTrigger={errored}>
        <Flex alignItems='center' flexDirection='column' textAlign='center'>
          <Title color='white' mb='10px'>
            Oops, Something Went Wrong
          </Title>

          <P maxWidth='500px' color='white'>
            Please go back and try again or contact{' '}
            <strong>support@alomoves.com</strong> and we'll get to the bottom of
            it.
          </P>

          <Button
            onClick={() => window.history.back()}
            variant='secondary'
            width='100%'
            maxWidth='450px'
            mt='32px'
            id='loading-back'
          >
            Go Back
          </Button>
        </Flex>
      </Fade>
    </FlexFull>
  )
}

export default Loading
